const styles = {
  headingView: {
    marginBottom: 32,
    width: "100%",
  },
};

export default styles;
